export default __webpack_public_path__ + "static/media/cnaps-bg.1a920276.svg";